import { config } from '@/config.js'

export default {
    title: "SmarterFinancial - for Web",
    locale: localStorage.getItem('locale'),
    version: config.version,
    ambientes: config.api.ambientes,
    ambiente: null,
    locales: [
      {name: 'en', text: 'English'},
      {name: 'es', text: 'Español'},
    ],
    localeSelectable: true,
    primaryTheme: 'dark',
    secondaryTheme: 'dark',
    historyPermission: true,
    layout: 'layout-admin',
    user: null,
    listaPersonas:null,
    personaBusqueda:null,
    activeTask: null,
    activeTaskProps: null,
    showActiveTask: false,
    closeRelatedTasks:false,//la uso para ponerla en true cuando se cierra el coso de activeTask y quiero cerrar otras cosas relacionadas
    activeSubTask: null,
    activeSubTaskProps: null,
    showActiveSubTask: false,
    showDialog:false,
    loading: false,
    fechaNotificacionVista: null,
    debugModeOn: false, // si 'true;  muestra información adicional en las pantallas y consola
    error: {value:false},
    alert: {
      show: false,
      color: '',
      text: '',
      icon: '',
      dismissible: false
    },
    parametrosGenerales:{},
    UiCustomUserSettings:{
      temaOscuro: false,
      mostrarTareasFrecuentes: false,
      mostrarRecordatorios: false,
      empresaPredeterminadaId: 0,
      canalVentaPredeterminadoId: 0,
      busquedaPersonaPor: 'Documento',
    },
    UiColors:{
        crudToolbarList: 'orange',
        crudToolbarDetail: 'orange',
        crudToolbarDetailButtons: 'orange darken-1',
    },
    UiConfig:[], // Acá se cargan los menúes del sistema
    reporteActivo:null,
    parametrosReporte:[],
    redirect:null,
    modoCargaRapidaComer:false
  } 